/**
 * Hit testing placed cats in world space (axis-aligned box in body local space).
 */

import type { CatArchetype, CatState } from './types.js';

/** True if world point (wx, wy) lies inside the cat's body AABB. */
export function hitTestCat(
  state: CatState,
  archetype: CatArchetype,
  wx: number,
  wy: number,
): boolean {
  const dx = wx - state.x;
  const dy = wy - state.y;
  const cos = Math.cos(-state.rotation);
  const sin = Math.sin(-state.rotation);
  const lx = dx * cos - dy * sin;
  const ly = dx * sin + dy * cos;
  const pad = 6;
  return Math.abs(lx) <= archetype.width / 2 + pad && Math.abs(ly) <= archetype.height / 2 + pad;
}

/** Find the topmost cat (smallest y) under a world point. */
export function findCatAtPoint(
  states: readonly CatState[],
  archetypes: ReadonlyMap<string, CatArchetype>,
  wx: number,
  wy: number,
): CatState | null {
  let best: CatState | null = null;
  for (const state of states) {
    const archetype = archetypes.get(state.archetypeId);
    if (!archetype) continue;
    if (!hitTestCat(state, archetype, wx, wy)) continue;
    if (!best || state.y < best.y) best = state;
  }
  return best;
}
